<template>
  <div style="display: flex; justify-content: space-between">
    <GeneralItem
      title="Nombre moyen"
      subTitle="assurés principaux"
      :tval="general?.insured?.tval"
      :prct="general?.insured?.prct"
      :arrow="general?.insured?.arrow"
    />

    <GeneralItem
      title="Age moyen"
      subTitle="assurés principaux"
      :tval="general?.age_mean?.tval"
      :prct="general?.age_mean?.prct"
      :arrow="general?.age_mean?.arrow"
    />

    <GeneralItem
      title="Nombre moyen"
      subTitle="Ayants droit"
      :tval="general?.benef?.tval"
      :prct="general?.benef?.prct"
      :arrow="general?.benef?.arrow"
    />

    <GeneralItem
      title="Coefficient familial"
      :tval="general?.family_coef?.tval"
      :prct="general?.family_coef?.prct"
      :arrow="general?.family_coef?.arrow"
    />
  </div>
</template>

<script>
import GeneralItem from "./GeneralItem.vue";

export default {
  components: {
    GeneralItem,
  },
  props: {
    general: {
      type: Object,
      required: true,
    },
  },
};
</script>
